import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ControllerApiPath } from '../services/constant';
import { SharedServiceService } from '../services/shared-service.service';

export interface DataAnalysisRequestPayload {
  memberIds: string[];
  startDate: string;
  endDate: string;
}

/** Per-member glucose (or similar) distribution as percentages. */
export interface DataAnalysisRangeBreakdown {
  veryHigh: number;
  high: number;
  low: number;
  inRange: number;
  veryLow: number;
}

export interface DataAnalysisMemberRow {
  name?: string;
  memberId: string;
  range: DataAnalysisRangeBreakdown;
}

export interface DataAnalysisResultPayload {
  startDate: string;
  endDate: string;
  members: DataAnalysisMemberRow[];
}

/** API wrapper: POST .../members/data-analysis */
export interface DataAnalysisResponse {
  result: DataAnalysisResultPayload;
}

@Injectable({
  providedIn: 'root',
})
export class DataAnalysisService {
  constructor(
    private http: HttpClient,
    private sharedService: SharedServiceService
  ) {}

  submitRequest(
    payload: DataAnalysisRequestPayload
  ): Observable<DataAnalysisResponse> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url =
      this.sharedService.baseUrl() + ControllerApiPath.members + '/data-analysis';
    return this.http.post<DataAnalysisResponse>(url, payload, { headers });
  }
}
